import React               from "react";
import {Grid, makeStyles}                 from '@material-ui/core';

const useStyles = makeStyles(theme =>({
  questionContainer:{
    width: "100%",
    height:"100%",
  },
  reading: {
    width: "80%",
    margin:"10px 0 10px 0 ",
    font: '22px lato',
    letterSpacing: '0.21px',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",

    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",
 
    }, 
  },
  table: {
    width: "100%",
    font: '22px lato',
    border: '1px solid black',
    [theme.breakpoints.down(1400)]:{
      font: " 18px lato",
      width: "95%",
    },
    [theme.breakpoints.down(1310)]:{
      font: "500 16px lato",
 
    },
    [theme.breakpoints.down(925)]:{
      font: "500 14px lato",

    },
    [theme.breakpoints.down(426)]:{
      font: "500 12px lato",

    }, 
  },
  tdTable: {
    padding: "0 1%",
    border: '1px solid black',
    textAlign: 'Left',
  },
  imgStyle: {
    alignItems: "center",
    width:'100%',
    height:'100%',
    // [theme.breakpoints.down(1400)]:{
    //   width:'85%px',
    //   height:'85%px',
    // },
  },
  marginCero:{
    margin: '0px'
  }
}));

const QuestionTable = (props) => {
  const classes = useStyles()
 

  return(
    <Grid container className={classes.questionContainer}>
      <p
        className={classes.reading}
      >
        2.Relaciona el país o países con las palabras  clave  que corresponden, según el texto:
      </p>
      <br/>
      <table className={classes.table}>
        <thead>
          <th style={{ width: "50%", border: '1px solid black',}}><b>Países</b></th>
          <th style={{width: "50%", border: '1px solid black',}}><b>Palabras clave</b></th>
        </thead>
        <tbody>
          <tr>
            <td className={classes.tdTable}>
              <p className={classes.marginCero}>
                1) Argentina y Uruguay
              </p>
              <p className={classes.marginCero}>
                2) Colombia
              </p>
              <p className={classes.marginCero}>
                3) Costa Rica
              </p>
              <p className={classes.marginCero}>
                4) Ecuador y Perú
              </p>
              <p className={classes.marginCero}>
                5) México
              </p>
            </td>
            <td className={classes.tdTable}>
              <p className={classes.marginCero}>
                a. comida, maíz, patrimonio
              </p>
              <p className={classes.marginCero}>
                b. café, carreta, boyero
              </p>
              <p className={classes.marginCero}>
                c. sabiduría, oral, selva
              </p>
              <p className={classes.marginCero}>
                d. popular, baile, formal
              </p>
              <p className={classes.marginCero}>
                e. festejo, música, fusión
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </Grid>
  )
}

export default QuestionTable;
